import { IconName, SanityInformationCard } from "@sourceful/shared-types";
import React from "react";
import { css, HeadingNew } from "@sourceful/shared-components";
import { IconTextNew, IconTextSize } from "../iconTextNew/IconTextNew";
import { BlockContent } from "@lib/sanity-components";

const customIconTextCss = css({
  ".text": {
    fs: "$font-size-fluid-title-m",
    fontWeight: "bold",
  },
});

const blockContentCss = css({
  color: "inherit",

  variants: {
    icon: {
      yes: {
        "@lg": {
          marginInlineStart: "calc($spacing-fluid-block-s + $sizes$iconS)",
        },
      },
      no: {},
    },
    border: {
      yes: {
        borderTop: "2px solid $colour-neutral-1-tint-80",
        mbs: "$spacing-fluid-block-xs",
        pbs: "$spacing-fluid-block-xs",
      },
      no: {
        marginBlockStart: "$block_m3",
      },
    },
  },

  defaultVariants: {
    border: "no",
  },

  "> :only-child, div > *": {
    margin: "0",
    marginBlockEnd: "$block_m1",
    fs: "$font-size-fluid-label-l",

    "&:last-child": {
      marginBlockEnd: "0",
    },

    a: {
      color: "inherit",

      "&:hover, &:focus": {
        textDecoration: "none",
      },
    },
  },
  //$space$spacing-fluid-block-s
});

const infoCardWrapperCss = css({
  padding: "$spacing-fluid-block-s",
  border: "1px solid $colour-neutral-1-tint-80",
  rad: "$radius-static-s",
  color: "$colour-darkest",
});

interface InformationCardProps {
  informationCard: SanityInformationCard;
}

const InformationCard = ({ informationCard }: InformationCardProps) => {
  if (informationCard?.iconName) {
    return (
      <div>
        <IconTextNew
          textAs="h3"
          icon={informationCard?.iconName as IconName}
          text={informationCard?.title}
          size={IconTextSize?.Large}
          className={customIconTextCss()}
        />
        {informationCard?.content && (
          <BlockContent
            wrapperClassName={blockContentCss({ icon: "yes" })}
            value={informationCard.content}
          />
        )}
      </div>
    );
  }

  return (
    <div className={infoCardWrapperCss()}>
      <HeadingNew
        variant={"Title"}
        as="h3"
        spacingBlockStart="None"
        spacingBlockEnd="None"
        css={{ fontWeight: "bold" }}
      >
        {informationCard?.title}
      </HeadingNew>
      {informationCard?.subTitle && (
        <HeadingNew
          variant="Title"
          as="p"
          size="Small"
          spacingBlockStart="Small"
          spacingBlockEnd="None"
          css={{ fontWeight: "bold" }}
        >
          {informationCard.subTitle}
        </HeadingNew>
      )}
      {informationCard?.content && (
        <BlockContent
          wrapperClassName={blockContentCss({ icon: "no", border: "yes" })}
          color={"inherit"}
          value={informationCard.content}
        />
      )}
    </div>
  );
};

export default InformationCard;
